import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { LangConstant } from "const";
import { PageTitle } from "components";
import { ChangePasswordForm, ChangeLanguageForm, ChangeMode, ServerInformation } from "./components";
import { useRole } from "hooks";

const Settings = () => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const { isServiceAdmin } = useRole();

  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });
  return (
    <Fragment>
      <PageTitle>{titleObjectContent.settings}</PageTitle>
      <Box>
        <ChangePasswordForm />
        {!isServiceAdmin && (
          <>
            <ChangeLanguageForm />
            <ChangeMode />
            <ServerInformation />
          </>
        )}
      </Box>
    </Fragment>
  );
};

export default Settings;
